import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { IsTouchContext } from './IsTouchContext';

export const IsTouchProvider = ({ children }: PropsWithChildren) => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    function handleTouch() {
      setIsTouchDevice(true);
    }

    function handleMouse(e) {
      if (e.pointerType !== 'touch') {
        setIsTouchDevice(false);
      }
    }

    // Check for initial touch support
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || window.matchMedia('(pointer: coarse)').matches) {
      setIsTouchDevice(true);
    }

    // Add event listeners to detect changes in input type
    window.addEventListener('touchstart', handleTouch, { passive: true });
    window.addEventListener('pointerdown', handleMouse);

    return () => {
      window.removeEventListener('touchstart', handleTouch);
      window.removeEventListener('pointerdown', handleMouse);
    };
  }, []);

  return <IsTouchContext.Provider value={isTouchDevice}>{children}</IsTouchContext.Provider>;
};
